import { useMemo } from "react";
import Arrow from "../LogoSVG/Arrow";

function ProjectsMobileItem({
  title,
  description,
  listTech,
  thumbnail,
  highLight,
  url,
}: any) {
  const { mainTitle, lastWord } = useMemo(() => {
    const words = title.trim().split(" ");
    return {
      mainTitle: words.slice(0, -1).join(" "),
      lastWord: words[words.length - 1],
    };
  }, [title]);

  return (
    <a href={url} className="flex flex-col mb-8 active:opacity-80">
      <div className="mb-1">
        <p
          className={`text-[16px] font-medium leading-tight flex flex-wrap ${
            highLight ? "text-custom-green" : ""
          }`}
        >
          {mainTitle && <span>{mainTitle}&nbsp;</span>}
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            {lastWord}
            <Arrow className="w-4 h-4 shrink-0 -translate-y-[1px]" />
          </span>
        </p>
      </div>

      <p className="text-[16px] mb-2 text-gray-5">{description}</p>

      <div className="w-[220px] h-[140px] overflow-hidden rounded-md mb-6 mt-2">
        <img
          src={thumbnail}
          alt="thumbnail"
          className="w-full h-full object-cover"
        />
      </div>
    </a>
  );
}

export default ProjectsMobileItem;
